import { useAuth0 } from '@auth0/auth0-react';
import { Button, ButtonProps } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const LogoutButton = ({ children, ...props }: ButtonProps) => {
  const { logout } = useAuth0();
  const { t } = useTranslation();
  const handleLogout = async () => {
    await logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <Button variant={'contained'} onClick={handleLogout} {...props}>
      {children ?? t('logout')}
    </Button>
  );
};
